import { TABLE_DATA } from '@/main/store/listEditTypes';

export const types = <const>{
	mutations: {
		PRACOVNIK_SELECT_MAPPER: 'PRACOVNIK_SELECT_MAPPER',
		NAKLADOVE_STREDISKO_MAPPER: 'NAKLADOVE_STREDISKO_MAPPER',
		MECHANIK_MAPPER: 'MECHANIK_MAPPER',
	},
	actions: {
		TABLE_DATA: 'tableDataFetch',
	},
};
